'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var ReturnsConfigProvider = require('./ReturnsConfigProvider.js');
var LanguageProvider = require('./LanguageProvider.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const NthProviders = _ref => {
  let {
    children
  } = _ref;
  const {
    noflakeUrl,
    handleError,
    isHipaaCompliant,
    moniker: retailerMoniker,
    versionName,
    themeVersionName,
    localeLanguage,
    localeCountry,
    localConfig
  } = ReturnsConfigProvider.useReturnsConfig();
  const queryTranslations = () => ({
    loading: false,
    translations: (localConfig === null || localConfig === void 0 ? void 0 : localConfig.queryTranslations()) ?? {}
  });
  const queryTheme = () => ({
    loading: false,
    theme: (localConfig === null || localConfig === void 0 ? void 0 : localConfig.queryTheme()) ?? {}
  });
  return /*#__PURE__*/React__namespace.createElement(nthHookContextAnalytics.AnalyticsProvider, {
    value: {
      noflakeUrl,
      errorCallback: handleError,
      isHipaaCompliant,
      data: {
        eventSchema: '',
        pageRetailerMoniker: '',
        productName: '',
        tag: isHipaaCompliant ? nthHookContextAnalytics.NoflakeTag.HIPAA_RETURNS : nthHookContextAnalytics.NoflakeTag.RETURNS
      }
    }
  }, localConfig ? /*#__PURE__*/React__namespace.createElement(LanguageProvider.LanguageProvider, {
    language: localConfig.queryTranslations()
  }, /*#__PURE__*/React__namespace.createElement(nthHookTranslations.LocalTranslationsConfigProvider, {
    queryTranslations: () => queryTranslations()
  }, /*#__PURE__*/React__namespace.createElement(nthHookTheme.LocalThemeConfigProvider, {
    queryTheme: () => queryTheme()
  }, children))) : /*#__PURE__*/React__namespace.createElement(nthHookTranslations.LomaTranslationsConfigProvider, {
    product: "narvarjs_translations",
    retailerMoniker: retailerMoniker,
    versionName: versionName,
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    preventFouc: true
  }, /*#__PURE__*/React__namespace.createElement(nthHookTheme.LomaThemeConfigProvider, {
    product: "narvarjs",
    retailerMoniker: retailerMoniker,
    versionName: themeVersionName,
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    preventFouc: true
  }, /*#__PURE__*/React__namespace.createElement(nthHookSettings.LomaSettingsConfigProvider, {
    product: "returns",
    retailerMoniker: retailerMoniker,
    versionName: versionName,
    localeLanguage: localeLanguage,
    localeCountry: localeCountry
  }, children))));
};

exports["default"] = NthProviders;
